export const LOOKER_URL = 'https://looker.league.com';
export const ANALYTICS_EVENT_HR_ADMIN_INSIGHTS = 'insights';
export const ENROLLMENT_SURVEY_STRING = 'ffWNaYaw';
export const SPENDING_ACCOUNT_SURVEY_STRING = 'oLbo0DY5';
export const BILLING_INSIGHTS_DASHBOARD_ID = 'billing-report';
